import { Box } from "@mui/material";
import { getColorByComponentType } from "../../program-calendar/utils/common";
import {
  TEMPLATE_SIDEBAR_BOTTOM_NAVIGATION_HEIGHT,
  TEMPLATE_SIDEBAR_HEADING_HEIGHT,
} from "./SidebarTemplate";
import { SidebarTabs } from "../../../constants";
import React from "react";
import {
  ComponentTemplateDto,
  ComponentType,
} from "@growth-machine-llc/stridist-api-client";
import TemplateSidebarTitle from "./TemplateSidebarTitle";
import TemplateSidebarDetailsTab from "./TemplateSidebarDetailsTab";
import TemplatePreviewTab from "./TemplatePreviewTab";
import { useTemplateSidebar } from "../../../contexts/TemplateSidebarContext";
import BottomNavigation from "./BottomNavigation";

interface ISidebarTemplateContentProps {
  type: ComponentType;
  componentTemplate: ComponentTemplateDto;
}

const SidebarTemplateContent = (props: ISidebarTemplateContentProps) => {
  const { type, componentTemplate } = props;
  const color = getColorByComponentType(type);
  const content = componentTemplate.content;
  const { activeTab: initTab } = useTemplateSidebar();

  const getTabsContent = (activeTab: SidebarTabs) => {
    switch (activeTab) {
      case SidebarTabs.DETAILS:
        return (
          <TemplateSidebarDetailsTab
            componentData={{ ...componentTemplate, type } as any}
            coachId={componentTemplate.coachId}
          />
        );
      case SidebarTabs.PREVIEW:
        return <TemplatePreviewTab componentTemplate={componentTemplate} />;

      default:
        break;
    }
  };
  const contentHeight = `calc(100% - ${TEMPLATE_SIDEBAR_HEADING_HEIGHT}px - ${TEMPLATE_SIDEBAR_BOTTOM_NAVIGATION_HEIGHT}px)`;

  return (
    <>
      <TemplateSidebarTitle type={type} />

      <Box
        overflow={"auto"}
        height={contentHeight}
        display={"flex"}
        sx={{
          scrollbarGutter: "unset",
          overscrollBehavior: "contain",
        }}
      >
        <Box width={1}>{content && getTabsContent(initTab)}</Box>
      </Box>

      <BottomNavigation type={type} />
    </>
  );
};

export default SidebarTemplateContent;
